<template>
  <div
    class="d-flex align-items-center justify-content-center h-100 px-2 py-4 px-md-5"
  >
    <form
      ref="form"
      class="rtl text-right"
      method="POST"
      :action="urls.signup + queryParams"
    >
      <h1 class="mb-4 page-title">ثبت‌نام</h1>
      <div class="form-row">
        <div
          v-if="
            !isRubikaPanelSignup && !isSheypoorPanelSignup && !isTechnolifePanelSignup && !isBasalamPanelSignup
          "
          class="form-group col-6 y-text-input"
        >
          <label for="firstNameInput">نام</label>
          <input
            v-model="first_name"
            id="firstNameInput"
            :class="['form-control', { 'has-error': firstNameErrors }]"
            type="text"
            name="first_name"
            placeholder="نام"
          />
          <div class="invalid-feedback d-block fanum">
            {{ firstNameErrors }}
          </div>
        </div>
        <div
          v-if="
            !isRubikaPanelSignup && !isSheypoorPanelSignup && !isTechnolifePanelSignup && !isBasalamPanelSignup
          "
          class="form-group col-6 y-text-input"
        >
          <label for="lastNameInput">نام خانوادگی</label>
          <input
            v-model="last_name"
            id="lastNameInput"
            :class="['form-control', { 'has-error': lastNameErrors }]"
            type="text"
            name="last_name"
            placeholder="نام خانوادگی"
          />
          <div class="invalid-feedback d-block fanum">
            {{ lastNameErrors }}
          </div>
        </div>
      </div>

      <input
        name="email"
        v-model="email"
        id="emailInput"
        v-if="
          isSMSPanelSignup ||
            isDivarPanelSignup ||
            isRubikaPanelSignup ||
            isSheypoorPanelSignup ||
            isTechnolifePanelSignup ||
            isBasalamPanelSignup
        "
        type="hidden"
      />

      <div v-else class="form-group y-text-input">
        <label for="emailInput">ایمیل</label>
        <input
          v-model="email"
          id="emailInput"
          :class="['form-control', { 'has-error': emailErrors }]"
          type="text"
          name="email"
          placeholder="مثال: yourmail@sample.com"
        />
        <div class="invalid-feedback d-block fanum">
          {{ emailErrors }}
        </div>
      </div>

      <div class="form-group y-text-input">
        <label for="phoneInput">شماره موبایل</label>
        <input
          v-model="phone"
          id="phoneInput"
          :class="['form-control', { 'has-error': phoneErrors }]"
          type="tel"
          name="phone"
          placeholder="مثال: 09123456789"
        />
        <div class="invalid-feedback d-block fanum">
          {{ phoneErrors }}
        </div>
      </div>
      <div class="form-group y-text-input">
        <label for="passwordInput">گذرواژه</label>
        <input
          v-model="password1"
          id="passwordInput"
          :class="['form-control', { 'has-error': passwordErrors }]"
          :type="showPassword1 ? 'text' : 'password'"
          name="password1"
          placeholder="گذرواژه"
        />
        <div
          @click="showPassword1 = !showPassword1"
          :class="
            `show-password-icon far fa-eye${showPassword1 ? '' : '-slash'}`
          "
        ></div>
        <div class="invalid-feedback d-block fanum">
          {{ passwordErrors }}
        </div>
      </div>
      <div class="form-group y-text-input">
        <label for="confirmPassword">تکرار گذرواژه</label>
        <input
          v-model="password2"
          id="confirmPassword"
          :class="['form-control', { 'has-error': confirmPasswordErrors }]"
          :type="showPassword2 ? 'text' : 'password'"
          name="password2"
          placeholder="تکرار گذرواژه"
        />
        <div
          @click="showPassword2 = !showPassword2"
          :class="
            `show-password-icon far fa-eye${showPassword2 ? '' : '-slash'}`
          "
        ></div>
        <div class="invalid-feedback d-block fanum">
          {{ confirmPasswordErrors }}
        </div>
      </div>

      <div class="form-check confirm-rules">
        <input
          v-model="isConfirmedRules"
          class="form-check-input"
          type="checkbox"
          id="confirm-rules"
        />
        <label class="form-check-label" for="confirm-rules">
          با
          <a
            href="https://accounts-cdn.yektanet.com/static/terms/privacy-policy.pdf"
            target="_blank"
          >
            شرایط رازداری و حفظ حریم خصوصی
          </a>
          و
          <a
            href="https://accounts-cdn.yektanet.com/static/terms/terms-of-services.pdf"
            target="_blank"
          >
            استفاده از خدمات
          </a>
          موافقت میکنم.
        </label>
        <div class="invalid-feedback d-block fanum">
          {{ confirmedRules[0] }}
        </div>
      </div>

      <button
        v-if="isRubikaPanelSignup"
        type="submit"
        class="y-signup-btn mt-3"
      >
        تایید و ثبت‌نام در سوشال ادز
      </button>
      <button
        v-else-if="isSheypoorPanelSignup"
        type="submit"
        class="y-signup-btn mt-3"
      >
        تایید و ثبت‌نام در شیپور
      </button>
      <button
        v-else-if="isTechnolifePanelSignup"
        type="submit"
        class="y-signup-btn mt-3"
      >
        تایید و ثبت‌نام در تکنولایف
      </button>
      <button v-else type="submit" class="y-signup-btn mt-3">
        تایید و ثبت‌نام در یکتانت
      </button>

      <div class="divider mb-1">
        <div class="text text-center">یا</div>
      </div>

      <a
        :href="urls.googleLogin"
        class="google-btn mb-1"
        data-gtm-name="login_google_register"
      >
        <div class="label">ثبت‌نام با گوگل</div>
        <div class="icon">
          <img width="24" height="24" :src="signupBnrs.googleLogo" />
        </div>
      </a>

      <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />

      <input
        v-if="redirectFieldValue"
        type="hidden"
        :name="redirectFieldName"
        :value="redirectFieldValue"
      />

      <div
        v-if="serverError.nonFieldErrors"
        class="mt-0 error-text text-center mb-4"
      >
        {{ serverError.nonFieldErrors }}
      </div>

      <div class="already-have-account">
        <span style="color: #444">قبلا ثبت‌نام کرده‌اید؟</span>
        <a :href="loginUrl">
          ورود به حساب کاربری
        </a>
      </div>
    </form>
  </div>
</template>

<script>
import FieldInput from "~/components/FieldInput.vue";

import { perToEngDigits, getParam } from "~/utils";

export default {
  components: { FieldInput },
  data: () => ({
    ...serverData,
    signupBnrs,
    isConfirmedRules: false,
    showPassword1: false,
    showPassword2: false,
    firstNameRules: [],
    lastNameRules: [],
    emailRules: [],
    phoneRules: [],
    passwordRules: [],
    confirmPasswordRules: [],
    confirmedRules: [],
  }),
  computed: {
    loginUrl() {
      return this.urls.login + window.location.search;
    },
    queryParams() {
      return window.location.href.split("?")[1]
        ? "?" + window.location.href.split("?")[1]
        : "";
    },
    firstNameErrors() {
      return this.firstNameRules[0] || this.serverError.first_name;
    },
    lastNameErrors() {
      return this.lastNameRules[0] || this.serverError.last_name;
    },
    phoneErrors() {
      return this.phoneRules[0] || this.serverError.phone;
    },
    emailErrors() {
      return this.emailRules[0] || this.serverError.email;
    },
    passwordErrors() {
      return this.passwordRules[0] || this.serverError.password1;
    },
    confirmPasswordErrors() {
      return this.confirmPasswordRules[0] || this.serverError.password2;
    },
  },
  watch: {
    phone(newVal) {
      this.phone = perToEngDigits(newVal);
      if (this.isSMSPanelSignup) {
        this.email = this.phone + "@sms-panel.yektanet.com";
      }
      if (this.isDivarPanelSignup) {
        this.email = this.phone + "@divar-panel.yektanet.com";
      }
      if (this.isRubikaPanelSignup) {
        this.email = this.phone + "@rubika-panel.yektanet.com";
      }
      if (this.isSheypoorPanelSignup) {
        this.email = this.phone + "@sheypoor-panel.yektanet.com";
      }
      if (this.isTechnolifePanelSignup) {
        this.email = this.phone + "@technolife.yektanet.com";
      }
      if (this.isBasalamPanelSignup) {
        this.email = this.phone + "@basalam-panel.yektanet.com";
      }
    },
    password1(newVal) {
      this.password1 = perToEngDigits(newVal);
    },
    password2(newVal) {
      this.password2 = perToEngDigits(newVal);
    },
  },
  mounted() {
    this.$refs.form.addEventListener("submit", (e) => {
      this.firstNameRules = [
        this.vRules.required(
          this.$t("validation_message.firstName_is_required")
        )(this.first_name),
      ].filter((rule) => typeof rule !== "boolean");
      this.lastNameRules = [
        this.vRules.required(
          this.$t("validation_message.lastName_is_required")
        )(this.last_name),
      ].filter((rule) => typeof rule !== "boolean");
      this.emailRules = [
        this.vRules.required(this.$t("validation_message.email_is_required"))(
          this.email
        ),
        this.vRules.email()(this.email),
      ].filter((rule) => typeof rule !== "boolean");
      this.phoneRules = [
        this.vRules.required(this.$t("validation_message.phone_is_required"))(
          this.phone
        ),
        this.vRules.phone()(this.phone),
      ].filter((rule) => typeof rule !== "boolean");
      this.passwordRules = [
        this.vRules.required(
          this.$t("validation_message.password_is_required")
        )(this.password1),
        this.vRules.password()(this.password1),
      ].filter((rule) => typeof rule !== "boolean");
      this.confirmPasswordRules = [
        this.vRules.required(
          this.$t("validation_message.password_repeat_is_required")
        )(this.password2),
        this.vRules.password_repeat(this.password1)(this.password2),
      ].filter((rule) => typeof rule !== "boolean");
      this.confirmedRules = [
        ...(this.isConfirmedRules
          ? []
          : ["لطفا موافقت خود با قوانین را تایید کنید."]),
      ];

      const isDedicatedPanelSignup = [
        "yektanet-rubika-adv",
        "yektanet-sheypoor-adv",
        "yektanet-technolife-adv",
        "yektanet-retail-basalam-adv",
      ].includes(getParam("account_custom_type"));

      const validations = [
        ...(isDedicatedPanelSignup ? [] : this.firstNameRules),
        ...(isDedicatedPanelSignup ? [] : this.lastNameRules),
        ...this.emailRules,
        ...this.phoneRules,
        ...this.passwordRules,
        ...this.confirmPasswordRules,
        ...this.confirmedRules,
      ];

      if (!validations.length) {
        if (/^9\d{9}$/.test(this.phone)) {
          this.phone = "0" + this.phone;
        } else if (/^\+989\d{9}$/.test(this.phone)) {
          this.phone = this.phone.replace("+98", "0");
        }
      } else {
        e.preventDefault();
      }
    });
  },
};
</script>

<style scoped lang="scss">
.rtl {
  direction: rtl;
}

.y-signup-btn {
  padding: 8px 20px;
  background: #00948b;
  color: #ffffff;
  width: 100%;
  outline: unset;
  border-radius: 8px;
  border: unset;
  line-height: 24px;
  transition: all 0.3s;

  &:focus {
    background-color: #006e67;
    box-shadow: 0 0 0 0.2rem rgba(38, 164, 156, 0.5);
  }
  &:hover {
    background-color: #006e67;
  }
}
.y-text-input {
  position: relative;
  text-align: right;
  margin-bottom: 0.5rem;

  label {
    font-weight: 500;
    color: #8c8c8c;
  }
  input {
    border-radius: 8px;
    height: 40px;
    direction: rtl;
    box-shadow: none;
    border-color: #ced4da;

    &::placeholder {
      color: #bfbfbf;
      font-family: FaNum;
    }

    &:focus {
      box-shadow: 0 0 0px 1px #006f68;
      border-color: transparent;
    }
  }

  .has-error {
    box-shadow: 0 0 0px 1px #f43f5e;
    border-color: transparent;
  }

  .show-password-icon {
    position: absolute;
    cursor: pointer;
    color: #8c8c8c;
    left: 16px;
    top: 38px;
  }
}

.confirm-rules {
  padding-right: 3px;

  input[type="checkbox"] {
    transform: scale(1.5);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-origin: border-box;
    border: 1px solid #6b7280;
    color: #00948b;
    display: inline-block;
    flex-shrink: 0;
    height: 1rem;
    padding: 0;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    width: 1rem;
    border-radius: 4px;
  }

  input[type="checkbox"]:checked {
    background-color: currentColor;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 12'%3E%3Cpath stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M1 5.917 5.724 10.5 15 1.5'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 0.55em 0.55em;
    border-color: transparent;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  label {
    font-size: 12px;
    font-weight: 500;
    padding-right: 28px;
    color: #595959 !important;

    a {
      color: #595959 !important;
      text-decoration: underline;
    }
  }
}

.google-btn {
  display: block;
  padding: 8px 20px;
  background: #ea4335;
  color: #ffffff;
  border-radius: 8px;
  text-align: center;
  position: relative;
  line-height: 24px;
  text-decoration: none;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 8px;
    width: 34px;
    height: 34px;
    background-color: #fff;
  }
}

.already-have-account {
  font-size: 12px;
  font-weight: 500;
  margin-top: 16px;

  a {
    color: #00948b;
    text-decoration: none;
  }
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
}
</style>
